<template>
  <b-modal v-model="modalShow" centered hide-header hide-footer no-close-on-backdrop>
    <div class="d-block text-center modal-container">
      <div class="content-subject">{{ $t('error.failedToProcess') }}</div>
      <div class="content-desc">
        {{ $t('selfcheck.useTouchPanel') }}
      </div>
      <div class="buttons">
        <so-quit-button @click="handleQuit" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SoQuitButton from '@/components/common/SoQuitButton'

export default {
  components: {
    SoQuitButton,
  },
  computed: {
    ...mapGetters({
      isShowingSelfcheckErrorModal: 'modal/isShowingSelfcheckErrorModal',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    modalShow: {
      get() {
        return this.isShowingSelfcheckErrorModal
      },
      set(value) {
        this.setShowingModal(value)
      },
    },
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
      setShowingModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async handleQuit() {
      await this.deauth()
      this.setShowingModal(false)

      if (this.isApp) {
        window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/home`
      } else {
        if (this.$route.path === '/') return
        this.$router.push({ path: '/' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
  padding-bottom: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
  }
  &-desc {
    text-align: start;
    padding: 20px 0;
    font-size: 14px;
  }
}
.buttons {
  width: 100%;
  display: flex;
  justify-content: center;
}
.button-quit {
  background: #d21b24 !important;
  width: 240px;
  height: 40px;
  border: none;
  font-weight: bold;

  &:hover,
  &:active {
    background-color: #d21b24 !important;
  }

  img {
    width: 18px;
    height: 18px;
    color: #fff;
    margin: -5px 8px 0 0;
  }
}
</style>
